import React from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { withTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { t } from "i18next";
import Card from "./Card";
import CardMobile from "./CardMobile";
import PopUp from "./popup";
import lotteryTicketNumbers from "../../../shared/index";
import LottoHeader from "../../../shared/lotto-header";

// prepare tickets initial state
let Card_data = [];
const prep_card_data = (arg) => {
  let arr = [];
  for (let i = 0; i < arg; i++) {
    arr.push({
      card_id: i,
      card_count: 0,
      Mega_count: 0,
      selected_digits: [],
    });
  }
  Card_data = arr;
};
prep_card_data(40);

// prepare checkbox value object
let addFields = [
  {
    iChecked: "checked",
    iChecked2: "",
    iChecked4: "",
    iChecked8: "",
    ticket_type: "single-ticket",
    draws: "1",
  },
];

// prepare checkbox value object
let selectObject = [
  {
    draws: "1",
    discount: "5",
  },
];

// popup data array
let remaining_data = [];

// AJAX callback url
const ajax_url = nylottery_ajax_obj.ajax_url;
const currentLang = window.location.pathname.split("/")[1];

const lotto = "lotto-ny-us";

let total_cost_of_tickets = {
  price: (() => (0).toFixed(2))(),
};

class WidgetFrontend extends React.Component {
  constructor(props) {
    super(props);
    this.addLessCards = this.addLessCards.bind(this);
    this.addMoreCards = this.addMoreCards.bind(this);
    this.addTicketCards = this.addTicketCards.bind(this);
    this.allQuickPick = this.allQuickPick.bind(this);
    this.calculatePrice = this.calculatePrice.bind(this);
    this.cardMobile = this.cardMobile.bind(this);
    this.clear = this.clear.bind(this);
    this.clearMobile = this.clearMobile.bind(this);
    this.deleteMobile = this.deleteMobile.bind(this);
    this.detectWindowResize = this.detectWindowResize.bind(this);
    this.editLineFn = this.editLineFn.bind(this);
    this.handleUpdateState = this.handleUpdateState.bind(this);
    this.loopDigits = this.loopDigits.bind(this);
    this.popup = this.popup.bind(this);
    this.PopUpOnClick = this.PopUpOnClick.bind(this);
    this.popup_continue = this.popup_continue.bind(this);
    this.quickPick = this.quickPick.bind(this);
    this.quickPickEdit = this.quickPickEdit.bind(this);
    this.quickPickMobile = this.quickPickMobile.bind(this);
    this.quickPickSelected = this.quickPickSelected.bind(this);
    this.quickPickSingle = this.quickPickSingle.bind(this);
    this.submitMobile = this.submitMobile.bind(this);
    this.undo = this.undo.bind(this);
    this.updateMegaSelected = this.updateMegaSelected.bind(this);
    this.updateMegaSelectedMobile = this.updateMegaSelectedMobile.bind(this);
    this.updateTicketDigitSelcted = this.updateTicketDigitSelcted.bind(this);
    this.updateTicketDigitSelctedMobile =
      this.updateTicketDigitSelctedMobile.bind(this);

    // state vars
    this.state = {
      apikey: "",
      b_disabled: "disabled",
      card_data: Card_data,
      cardCount: 10,
      count_popup: 0,
      current_clicked_id: null,
      current_lottery: lotteryTicketNumbers[16].NewYorkLotto,
      editline_id: null,
      ignorePopUp: false,
      inputCount: 4,
      isPresentable: [0, 1],
      maximum_tickets: 40,
      mobile_editable: false,
      mobile_stats: true,
      offSwitch: false,
      popup_button_back: DOMPurify.sanitize(t("popupBack")),
      popup_call_to_action_button: " ",
      popup_dashboard_text: "",
      popup_heading: "",
      popup_message: "",
      popup_show: false,
      prevClick: 0,
      PREVIOUS_UID: null,
      remaining_data: null,
      remaining_incomplete_lines: false,
      selected_digits_mobile_click: 0,
      selected_digits_mobile: 0,
      selectValue: selectObject,
      ticket_options: addFields,
      toggle: true,
      total_cost_of_tickets: total_cost_of_tickets,
      tValue: "",
      updateState: false,
      widthMeasure: false,
      xCount: 0,
      breakpoints_up: [
        {
          medium: "40em",
          large: "71.875em",
          xlarge: "87.5em",
        },
      ],
      cssChecked: [
        {
          yes: "checked",
          no: "",
        },
      ],
      lotto_results: {
        data: [],
      },
      drawRemainingTime: "",
      browserDOM: false,
    };
    this.currentUrl = "";
    this.intervalId = null;
  }

  // persist state
  handleUpdateState = (stateName, updatedState) => {
    const { dispatch, lotto_miniState, lotto_aff } = this.props;
    if (stateName === "idev") {
      const newState = {
        ...lotto_aff,
        [stateName]: updatedState,
      };
      dispatch({
        type: "LOTTO_AFF",
        payload: { [stateName]: newState[stateName] },
      });
    } else {
      const newState = {
        ...lotto_miniState,
        [stateName]: updatedState,
      };
      dispatch({
        type: "LOTTO_MINI",
        payload: { [stateName]: newState[stateName] },
      });
    }

    // this.sessionData(read);
    // read=false;
  };

  // continue fn
  contPlay = async () => {
    if (document.getElementsByClassName("widget-ticket-summary-button")[0]) {
      document.getElementsByClassName(
        "widget-ticket-summary-button"
      )[0].disabled = "disabled";
    }
    document.getElementsByClassName("loader")[0].style = "display: block";

    if (this.popup()) return;
    if (this.checkForIncompleteLines() && !this.state.ignorePopUp) return;
    let moreOptions = [];

    if (this.state.ticket_options[0].ticket_type === "single-ticket") {
      moreOptions.push([this.state.ticket_options[0].ticket_type]);
    } else if (this.state.ticket_options[0].ticket_type === "multi-draws") {
      moreOptions.push(this.state.ticket_options[0].ticket_type);
    }

    let arr = [];
    for (let i = 0; i < this.ticketsArray.length; i++) {
      if (
        this.ticketsArray[i].length > this.state.current_lottery.maximum_digits
      )
        arr.push(this.ticketsArray[i]);
    }
    this.ticketsArray = arr;

    let form_data = new FormData();
    form_data.append("action", "postTickets");
    form_data.append("postData", JSON.stringify(this.ticketsArray));
    form_data.append("draw_data", JSON.stringify(this.state.ticket_options[0]));
    form_data.append("lottery", lotto);
    form_data.append("lang", currentLang);
    const { lotto_aff } = this.props;
    const { idev } = lotto_aff ? lotto_aff : "";
    if (idev) {
      form_data.append("idev", idev);
    }

    for (let key in moreOptions) {
      Array.isArray(moreOptions[key])
        ? form_data.append("select", JSON.stringify(moreOptions[key]))
        : form_data.append("ticket_type", moreOptions[key]);
    }

    await Axios({
      method: "POST",
      url: ajax_url,
      data: form_data,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    }).then(
      async (response) => {
        this.setState(() => ({ b_disabled: "disabled" })); // not working

        // add to cart and redirect to woocommerce cart page
        await this.addToCart(this.state.current_lottery.id);
        window.location.href = response.data["data"]["redirect_url"];
      },
      /* Note: it's important to handle errors here instead of a catch() block so that we don't swallow exceptions from actual bugs in components. */
      (error) => {
        console.log("Error: Check your internet connection.");
      }
    );
  };

  // idev fn
  get_idev() {
    const urlParams = new URLSearchParams(window.location.search);
    const myId = urlParams.get("idev_id");

    return myId;
  }

  // get price fn
  getPrice = async () => {
    let self = this;
    let params = { action: "ticketsPrice", lottery: lotto };

    await Axios({
      method: "GET",
      url: ajax_url,
      params: params,
    }).then(async function (response) {
      if (response.data.data) {
        self.setState((prevState) => ({
          current_lottery: {
            ...prevState.current_lottery,
            id: response.data["data"]["product_id"],
            price_per_ticket: response.data["data"]["t_price"],
          },
        }));
      }

      await self.calculatePrice(); // remove?
    });
  };

  // get draws res
  getDrawResults = async () => {
    let self = this;

    let url = `https://api.simbalotto.com/draws/${lotto}`;

    await Axios.get(url).then(
      async function (response) {
        if (response.data) {
          self.setState((prevState) => ({
            lotto_results: {
              ...prevState.lotto_results,
              data: response.data,
            },
          }));
        }
      },
      (error) => {
        // console.log('Error: Check your internet connection.');
      }
    );
  };

  // draw remaining time
  drawInTime = (date) => {
    let targetDate = new Date(date);
    let currentDate = new Date();
    let countdown = "";

    if (
      targetDate.getTime() === currentDate.getTime() ||
      targetDate.getTime() < currentDate.getTime()
    ) {
      return "DDAY";
    }

    let timeDiff = targetDate.getTime() - currentDate.getTime();

    let days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    let hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    let minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    let seconds = Math.floor((timeDiff / 1000) % 60);

    isNaN(days)
      ? (countdown = "DDAY")
      : (countdown = {
          days: days,
          seconds: seconds,
          minutes: minutes,
          hours: hours,
        });
    return countdown;
  };

  // add tickets to cart
  async addToCart(p_id) {
    await Axios.get("/shop/?post_type=product&add-to-cart=" + p_id).then(
      function (res) {},
      (error) => {
        console.log(error);
      }
    );
  }

  // random number(s) generator fns
  randomArrayInRange(min, max, n) {
    var arr = [];
    while (arr.length < n) {
      let r = Math.floor(Math.random() * (max - min + 1)) + min;
      if (arr.indexOf(r) === -1 && arr.includes(r) === false) {
        // these checks don't always work when trying not to add duplicates
        arr.push(r);
      }
    }
    return arr.sort(function (a, b) {
      return a - b;
    });
  }

  // random mega generator fns
  randomNumberInRange(min, max) {
    let one_number = [Math.floor(Math.random() * (max - min + 1)) + min];
    return one_number;
  }

  // loop card/ticket numbers
  loopDigits(card) {
    let lotteryArray = [];
    for (let index = 1; index <= card; index++) {
      lotteryArray.push(index);
    }
    return lotteryArray;
  }

  // tickets input buttons controller
  componentDidMount() {
    this.getPrice();
    this.getDrawResults();
    let idev_state = this.get_idev();
    if (idev_state) {
      this.handleUpdateState("idev", idev_state);
    }
    window.addEventListener("click", () => this.setState({ offSwitch: false }));
    window.addEventListener("load", this.detectWindowResize);
    window.addEventListener("resize", this.detectWindowResize);

    const tabIndex = sessionStorage.getItem("activeTabIndex");
    if (!tabIndex) {
      sessionStorage.setItem("activeTabIndex", 1);
    }

    this.intervalId = setInterval(() => {
      this.setState({
        drawRemainingTime: this.drawInTime(
          this.state.lotto_results.data[0]?.date?.toString()
        ),
      });
    }, 1000);
  }

  // detect a resize in the window element, tells if in tablet, mobile or desktop mode to set input
  detectWindowResize() {
    document.querySelector(".section").clientWidth >
    this.state.breakpoints_up[0].large
      ? this.setState({ widthMeasure: false })
      : this.setState({ widthMeasure: true });
  }

  // loop state and prepare tickets numbers array;
  loop = () => {
    let arr = [];
    // set state of the submit button to `enabled`
    for (let i = 0; i < this.state.card_data.length; i++) {
      if (
        this.state.b_disabled === "disabled" &&
        this.state.card_data[i].selected_digits.length >
          this.state.current_lottery.maximum_digits
      ) {
        // this.setState(() => ({ b_disabled: "" }));
        var total_value = document.querySelector(
          "#ny-lotto .widget-ticket-summary-content-total"
        );
        total_value.style.cssText = "color: #272727;";
      }
      arr.push(this.state.card_data[i].selected_digits);
    }
    this.ticketsArray = arr;
    return this.ticketsArray;
  };

  // Prepare AJAX post request
  componentDidUpdate(prevProps, prevState) {
    this.loop();
    this.observeDOMChanges();

    // calculate and update price
    if (
      !(prevState.card_data === this.state.card_data) ||
      !(
        prevState.ticket_options[0].ticket_type ===
        this.state.ticket_options[0].ticket_type
      ) ||
      !(prevState.selectValue === this.state.selectValue)
    ) {
      this.calculatePrice();
    }
  }

  observeDOMChanges() {
    const targetElement =
      document.getElementsByClassName("card__quick-pick")[0];

    if (!targetElement) {
      return;
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "childList" ||
          mutation.target === targetElement
        ) {
          this.handleDOMChange();
        }
      }
    });

    observer.observe(targetElement, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  handleDOMChange() {
    this.setState(
      {
        browserDOM: true,
      },
      () => {
        // this.forceUpdate();
      }
    );
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  // create input element fn
  Input({ handleClick, type, name, value, id, checked, text, data_tickets }) {
    return (
      <label>
        <input
          type={type}
          name={name}
          value={value}
          id={id}
          checked={checked}
          onChange={handleClick}
          data-tickets={data_tickets}
        />
        {text}
      </label>
    );
  }

  // cards input buttons
  InputCss({ handleClick, type, id, checked, className }) {
    return (
      <input
        checked={checked}
        className={className}
        data-i={id}
        id={id}
        key={id}
        onChange={handleClick}
        type={type}
      />
    );
  }

  // create button element fn (change back to Button)
  Button({ handleClick, type, id, className, text, disabled, title = "" }) {
    return (
      <button
        type={type}
        id={id}
        className={className}
        disabled={disabled}
        onClick={handleClick}
        title={title}
      >
        {text}
      </button>
    );
  }

  // handle input checkbox options
  handleCheckbox = async (e) => {
    let getDraw = e.target.getAttribute("data-tickets");
    await this.setState((prevState) => ({
      ticket_options: prevState.ticket_options.map((elements) => {
        if (e.target.value === "1") {
          return Object.assign({}, elements, {
            iChecked: "checked",
            iChecked2: "",
            iChecked4: "",
            iChecked8: "",
            ticket_type: "single-ticket",
            draws: "1",
          });
        } else if (e.target.value === "2") {
          return Object.assign({}, elements, {
            iChecked: "",
            iChecked2: "checked",
            iChecked4: "",
            iChecked8: "",
            ticket_type: "multi-draws",
            draws: "2",
          });
        } else if (e.target.value === "4") {
          return Object.assign({}, elements, {
            iChecked: "",
            iChecked2: "",
            iChecked4: "checked",
            iChecked8: "",
            ticket_type: "multi-draws",
            draws: "4",
          });
        } else if (e.target.value === "8") {
          return Object.assign({}, elements, {
            iChecked: "",
            iChecked2: "",
            iChecked4: "",
            iChecked8: "checked",
            ticket_type: "multi-draws",
            draws: "8",
          });
        } else return elements;
      }),
      selectValue: prevState.selectValue.map((elements) => {
        return Object.assign({}, elements, {
          draws: getDraw,
        });
      }),
    }));
  };

  // handle select box options
  handleSelect = async (e) => {
    let getDraw = e.target.selectedOptions[0].getAttribute("data-tickets");
    let getDisc = e.target.selectedOptions[0].getAttribute("data-discount");

    await this.setState((prevState) => ({
      selectValue: prevState.selectValue.map((elements) => {
        return Object.assign({}, elements, {
          draws: getDraw,
          discount: getDisc,
        });
      }),
    }));
  };

  // quick pick fn
  quickPick(event) {
    let UID;
    event.target.parentNode.parentNode.parentNode
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

    let card_id =
        event.target.parentNode.parentNode.parentNode.getAttribute("id"),
      allCardNumbers = document.querySelectorAll(
        `#ny-lotto #${card_id} .card__text.lottery`
      ),
      allMegaNumbers = document.querySelectorAll(`#ny-lotto #${card_id} .Mega`);

    let number_generator = (x) => {
      if (x === 0) {
        this.setState((prevState) => ({
          card_data: prevState.card_data.map((elements) => {
            if (elements.card_id == UID) {
              return Object.assign({}, elements, {
                card_count: this.state.current_lottery.maximum_digits,
                Mega_count: this.state.current_lottery.max_mega_digits,
                selected_digits: Card_data[UID].selected_digits,
              });
            } else return elements;
          }),
        }));
        return 1;
      } else {
        setTimeout(() => {
          Card_data[UID].selected_digits = this.randomArrayInRange(
            1,
            this.state.current_lottery.digits,
            this.state.current_lottery.maximum_digits
          ); // createRandomPick()

          Card_data[UID].selected_digits.push(
            this.randomNumberInRange(
              1,
              this.state.current_lottery.luckyDigits,
              this.state.current_lottery.max_mega_digits
            )
          ); // quickPickMega

          allCardNumbers.forEach((card) => {
            card.classList.remove("card__onClick");
            for (
              let index = 0;
              index < Card_data[UID].selected_digits.length;
              index++
            ) {
              let y = Card_data[UID].selected_digits;
              if (y[index] == card.innerText && !Array.isArray(y[index]))
                card.classList.add("card__onClick");
            }
          });

          allMegaNumbers.forEach((Mega) => {
            Mega.classList.remove("card__MegaOnClick");
            for (
              let index = 0;
              index < Card_data[UID].selected_digits.length;
              index++
            ) {
              let y = Card_data[UID].selected_digits;
              if (y[index] == Mega.innerText && Array.isArray(y[index]))
                Mega.classList.add("card__MegaOnClick");
            }
          });

          return number_generator(x - 1);
        }, 300);
      }
    };

    number_generator(5);
  }

  // quick pick edit fn
  quickPickEdit(event) {
    let UID;
    event.target.parentNode
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

    Card_data[UID].selected_digits = this.randomArrayInRange(
      1,
      this.state.current_lottery.digits,
      this.state.current_lottery.maximum_digits
    ); // createRandomPick()

    Card_data[UID].selected_digits.push(
      this.randomNumberInRange(
        1,
        this.state.current_lottery.luckyDigits,
        this.state.current_lottery.max_mega_digits
      )
    ); // quickPickMega

    this.setState((prevState) => ({
      card_data: prevState.card_data.map((elements) => {
        if (elements.card_id == UID) {
          return Object.assign({}, elements, {
            card_count: this.state.current_lottery.maximum_digits,
            Mega_count: this.state.current_lottery.max_mega_digits,
            selected_digits: Card_data[UID].selected_digits,
          });
        } else return elements;
      }),
    }));
  }

  // delete edit btn for mobile fn
  deleteMobile(event) {
    let UID,
      eventId = event.target.parentNode;

    eventId
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

    eventId.classList.remove("display");
    eventId.classList.add("none");

    this.setState((prevState) => ({
      card_data: prevState.card_data.map((elements) => {
        if (elements.card_id == UID && elements.selected_digits.length !== 0) {
          return Object.assign({}, elements, {
            selected_digits: [],
            card_count: 0,
            Mega_count: 0,
          });
        } else return elements;
      }),
    }));
    Card_data[UID].selected_digits = [];
  }

  // quick pick mobile
  quickPickMobile(event) {
    let UID,
      quick_pick_id =
        event.target.getAttribute("id") ||
        event.target.parentNode.getAttribute("id"),
      quick_pick_data =
        event.target.getAttribute("data-id") ||
        event.target.parentNode.getAttribute("data-id");

    if (quick_pick_data !== null) {
      quick_pick_data
        .split("-")
        .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

      for (let index = 0; index < UID; index++) {
        Card_data[
          this.state.selected_digits_mobile_click + index
        ].selected_digits = this.randomArrayInRange(
          1,
          this.state.current_lottery.digits,
          this.state.current_lottery.maximum_digits
        );

        Card_data[
          this.state.selected_digits_mobile_click + index
        ].selected_digits.push(
          this.randomNumberInRange(
            1,
            this.state.current_lottery.luckyDigits,
            this.state.current_lottery.max_mega_digits
          )
        );
        this.setState((prevState) => ({
          card_data: prevState.card_data.map((elements) => {
            if (
              elements.card_id ==
              this.state.selected_digits_mobile_click + index
            ) {
              return Object.assign({}, elements, {
                card_count: this.state.current_lottery.maximum_digits,
                Mega_count: this.state.current_lottery.max_mega_digits,
                selected_digits:
                  Card_data[this.state.selected_digits_mobile_click + index]
                    .selected_digits,
              });
            } else return elements;
          }),
        }));
      }

      this.setState({
        mobile_editable: true,
        selected_digits_mobile_click:
          this.state.selected_digits_mobile_click + UID,
        selected_digits_mobile: this.state.selected_digits_mobile + UID,
        activateSubmitButton: true,
      });
    } else {
      quick_pick_id
        .split("-")
        .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

      if (quick_pick_data !== null) {
        quick_pick_data
          .split("-")
          .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

        for (let index = 0; index < UID; index++) {
          Card_data[
            this.state.selected_digits_mobile_click + index
          ].selected_digits = this.randomArrayInRange(
            1,
            this.state.current_lottery.digits,
            this.state.current_lottery.maximum_digits
          );

          Card_data[
            this.state.selected_digits_mobile_click + index
          ].selected_digits.push(
            this.randomNumberInRange(
              1,
              this.state.current_lottery.luckyDigits,
              this.state.current_lottery.max_mega_digits
            )
          );
          this.setState((prevState) => ({
            card_data: prevState.card_data.map((elements) => {
              if (
                elements.card_id ==
                this.state.selected_digits_mobile_click + index
              ) {
                return Object.assign({}, elements, {
                  card_count: this.state.current_lottery.maximum_digits,
                  Mega_count: this.state.current_lottery.max_mega_digits,
                  selected_digits:
                    Card_data[this.state.selected_digits_mobile_click + index]
                      .selected_digits,
                });
              } else return elements;
            }),
          }));
        }

        this.setState({
          mobile_editable: true,
          selected_digits_mobile_click:
            this.state.selected_digits_mobile_click + UID,
          activateSubmitButton: true,
        });
      } else {
        quick_pick_id
          .split("-")
          .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

        this.setState((prevState) => ({
          card_data: prevState.card_data.map((elements) => {
            if (elements.card_id == UID) {
              return Object.assign({}, elements, {
                card_count: this.state.current_lottery.maximum_digits,
                Mega_count: this.state.current_lottery.max_mega_digits,
                selected_digits: Card_data[UID].selected_digits,
              });
            } else return elements;
          }),
        }));
      }
    }
  }

  //this quick pick method is used on mobile version where only one card in clicked
  quickPickSingle(event) {
    let UID = (() => {
      if (this.state.current_clicked_id !== null) {
        return this.state.current_clicked_id;
      } else return this.state.selected_digits_mobile_click;
    })();

    let allCardNumbers = document.querySelectorAll(
        `.card-mobiled.mobile .card__text.lottery`
      ),
      allMegaNumbers = document.querySelectorAll(`.card-mobiled.mobile .Mega`);

    Card_data[UID].selected_digits = this.randomArrayInRange(
      1,
      this.state.current_lottery.digits,
      this.state.current_lottery.maximum_digits
    );
    Card_data[UID].selected_digits.push(
      this.randomNumberInRange(
        1,
        this.state.current_lottery.luckyDigits,
        this.state.current_lottery.max_mega_digits
      )
    );

    this.setState((prevState) => ({
      card_data: prevState.card_data.map((elements) => {
        if (elements.card_id == UID) {
          return Object.assign({}, elements, {
            card_count: this.state.current_lottery.maximum_digits,
            Mega_count: this.state.current_lottery.max_mega_digits,
            selected_digits: Card_data[UID].selected_digits,
          });
        } else return elements;
      }),
    }));

    // adding the animation on quickpick
    allCardNumbers.forEach((card) => {
      card.classList.remove("card__onClick");
      for (
        let index = 0;
        index < Card_data[UID].selected_digits.length;
        index++
      ) {
        let y = Card_data[UID].selected_digits;
        if (y[index] == card.innerText && !Array.isArray(y[index]))
          card.classList.add("card__onClick");
      }
    });

    allMegaNumbers.forEach((Mega) => {
      Mega.classList.remove("card__MegaOnClick");
      for (
        let index = 0;
        index < Card_data[UID].selected_digits.length;
        index++
      ) {
        let y = Card_data[UID].selected_digits;
        if (y[index] == Mega.innerText && Array.isArray(y[index]))
          Mega.classList.add("card__MegaOnClick");
      }
    });
  }

  // quickPickAll fn
  allQuickPick(event) {
    document
      .querySelectorAll("#ny-lotto .card")
      .forEach((ticketCardQP, UID) => {
        let allCardNumbers = ticketCardQP.querySelectorAll(
            "#ny-lotto .card__number .card__text.lottery"
          ),
          allMegaNumbers = ticketCardQP.querySelectorAll(
            "#ny-lotto .card__number-Mega .card__text"
          ),
          RandomNumber = (data) => {
            let x = Math.floor(Math.random() * data);
            if (x < 1 || x > data) return RandomNumber(data);
            else return x;
          },
          createRandomPick = (number, max_digit, digits, prevDigits = []) => {
            let z = prevDigits;
            for (let index = 0; index < number; index++) {
              z.push(RandomNumber(digits));
            }
            z = [...new Set(z)];

            if (z.length < max_digit)
              return createRandomPick(
                max_digit - z.length,
                max_digit,
                digits,
                z
              );

            return z.sort(function (a, b) {
              return a - b;
            });
          };

        Card_data[UID].selected_digits = createRandomPick(
          this.state.current_lottery.maximum_digits,
          this.state.current_lottery.maximum_digits,
          this.state.current_lottery.digits
        );

        Card_data[UID].selected_digits.push([
          createRandomPick(
            this.state.current_lottery.max_mega_digits,
            this.state.current_lottery.max_mega_digits,
            this.state.current_lottery.luckyDigits
          ),
        ]);

        this.setState((prevState) => ({
          card_data: prevState.card_data.map((elements) => {
            if (elements.card_id == UID) {
              return Object.assign({}, elements, {
                card_count: 6,
                Mega_count: 1,
                selected_digits: Card_data[UID].selected_digits,
              });
            } else return elements;
          }),
        }));

        // animation on quickpick
        allCardNumbers.forEach((card) => {
          card.classList.remove("card__onClick");
          for (
            let index = 0;
            index < Card_data[UID].selected_digits.length;
            index++
          ) {
            let y = Card_data[UID].selected_digits;
            if (y[index] == card.innerText && !Array.isArray(y[index]))
              card.classList.add("card__onClick");
          }
        });
        allMegaNumbers.forEach((Mega) => {
          Mega.classList.remove("card__MegaOnClick");
          for (
            let index = 0;
            index < Card_data[UID].selected_digits.length;
            index++
          ) {
            let y = Card_data[UID].selected_digits;
            if (y[index] == Mega.innerText && Array.isArray(y[index]))
              Mega.classList.add("card__MegaOnClick");
          }
        });
      });
  }

  // clear button per card fn
  clear(event) {
    let id = event.target.getAttribute("childid");

    this.setState((prevState) => ({
      card_data: prevState.card_data.map((elements) => {
        if (elements.card_id == id && elements.selected_digits.length !== 0) {
          return Object.assign({}, elements, {
            selected_digits: [],
            card_count: 0,
            Mega_count: 0,
          });
        } else return elements;
      }),
    }));
    Card_data[id].selected_digits = [];

    let cardSelect = document.querySelectorAll(`#card-${id} .card__text`);

    cardSelect.forEach((item) =>
      item.classList.contains("card__onClick")
        ? item.classList.remove("card__onClick")
        : item.classList.contains("card__MegaOnClick")
        ? item.classList.remove("card__MegaOnClick")
        : null
    );
  }

  // clear method for mobile devices
  clearMobile(cardSet) {
    let id = this.state.selected_digits_mobile_click;

    if (cardSet !== "submit") {
      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == id && elements.selected_digits.length !== 0) {
            return Object.assign({}, elements, {
              selected_digits: [],
              card_count: 0,
              Mega_count: 0,
            });
          } else return elements;
        }),
      }));
    }
    Card_data[id].selected_digits = [];

    let cardSelect = document.querySelectorAll(
      `#poweraustralia .card__mobile .card__text`
    );

    cardSelect.forEach((item) =>
      item.classList.contains("card__onClick")
        ? item.classList.remove("card__onClick")
        : item.classList.contains("card__MegaOnClick")
        ? item.classList.remove("card__MegaOnClick")
        : null
    );
  }

  //update Megaball selected number mobile
  updateMegaSelectedMobile(UID, ticket_number) {
    let selectedCard = document.querySelector(
      `.card__mobile #cardTextMega-${UID}`
    );

    if (
      selectedCard.classList.contains("card__MegaOnClick") &&
      this.state.card_data[this.state.selected_digits_mobile].Mega_count >= 0
    ) {
      selectedCard.classList.remove("card__MegaOnClick");
      Card_data[this.state.selected_digits_mobile].selected_digits = Card_data[
        this.state.selected_digits_mobile
      ].selected_digits.filter((item) => (!Array.isArray(item) ? item : null));

      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == this.state.selected_digits_mobile) {
            return Object.assign({}, elements, {
              selected_digits:
                Card_data[this.state.selected_digits_mobile].selected_digits,
              Mega_count: elements.Mega_count - 1,
            });
          } else return elements;
        }),
      }));
    } else if (
      !selectedCard.classList.contains("card__MegaOnClick") &&
      this.state.card_data[this.state.selected_digits_mobile].Mega_count > 0
    ) {
      if (this.state.PREVIOUS_UID !== null)
        document
          .querySelector(
            `.card__mobile #cardTextMega-${this.state.PREVIOUS_UID}`
          )
          .classList.remove("card__MegaOnClick");

      selectedCard.classList.add("card__MegaOnClick");

      Card_data[this.state.selected_digits_mobile].selected_digits = Card_data[
        this.state.selected_digits_mobile
      ].selected_digits.filter((item) => (!Array.isArray(item) ? item : null));

      Card_data[this.state.selected_digits_mobile].selected_digits.push([
        Number(ticket_number),
      ]);

      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == this.state.selected_digits_mobile) {
            return Object.assign({}, elements, {
              selected_digits:
                Card_data[this.state.selected_digits_mobile].selected_digits,
            });
          } else return elements;
        }),
      }));
    } else if (
      !selectedCard.classList.contains("card__MegaOnClick") &&
      this.state.card_data[this.state.selected_digits_mobile].Mega_count <
        this.state.current_lottery.max_mega_digits
    ) {
      selectedCard.classList.add("card__MegaOnClick");

      Card_data[this.state.selected_digits_mobile].selected_digits.push([
        Number(ticket_number),
      ]);
      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == this.state.selected_digits_mobile) {
            return Object.assign({}, elements, {
              Mega_count: elements.Mega_count + 1,
              selected_digits:
                Card_data[this.state.selected_digits_mobile].selected_digits,
            });
          } else return elements;
        }),
      }));
    }
    this.setState({ PREVIOUS_UID: UID });
    return selectedCard;
  }

  //update Megaball selected number
  updateMegaSelected(UID, card_arg, ticket_number) {
    let selectedCard = document.querySelector(
      `#ny-lotto #card-${card_arg} #cardTextMega-${UID}`
    );

    if (
      selectedCard.classList.contains("card__MegaOnClick") &&
      this.state.card_data[card_arg].Mega_count >= 0
    ) {
      selectedCard.classList.remove("card__MegaOnClick");
      Card_data[card_arg].selected_digits = Card_data[
        card_arg
      ].selected_digits.filter((item) => (!Array.isArray(item) ? item : null));

      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == card_arg) {
            return Object.assign({}, elements, {
              selected_digits: Card_data[card_arg].selected_digits,
              Mega_count: elements.Mega_count - 1,
            });
          } else return elements;
        }),
      }));
    } else if (
      !selectedCard.classList.contains("card__MegaOnClick") &&
      this.state.card_data[card_arg].Mega_count < 1
    ) {
      selectedCard.classList.add("card__MegaOnClick");

      Card_data[card_arg].selected_digits.push([Number(ticket_number)]);
      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == card_arg) {
            return Object.assign({}, elements, {
              Mega_count: elements.Mega_count + 1,
              selected_digits: Card_data[card_arg].selected_digits,
            });
          } else return elements;
        }),
      }));
    }

    return selectedCard;
  }

  // update selected numbers mobile
  updateTicketDigitSelctedMobile(UID, ticket_number) {
    let selectedCard = document.querySelector(`.card__mobile #cardText-${UID}`);

    if (
      selectedCard.classList.contains("card__onClick") &&
      this.state.card_data[this.state.selected_digits_mobile].card_count >= 0
    ) {
      Card_data[this.state.selected_digits_mobile].selected_digits = Card_data[
        this.state.selected_digits_mobile
      ].selected_digits.filter((item) =>
        item !== Number(ticket_number) ? item : null
      );

      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == this.state.selected_digits_mobile) {
            return Object.assign({}, elements, {
              selected_digits:
                Card_data[this.state.selected_digits_mobile].selected_digits,
              card_count: elements.card_count - 1,
            });
          } else return elements;
        }),
      }));
      selectedCard.classList.remove("card__onClick");
    } else if (
      !selectedCard.classList.contains("card__onClick") &&
      this.state.card_data[this.state.selected_digits_mobile].card_count <
        this.state.current_lottery.maximum_digits
    ) {
      Card_data[this.state.selected_digits_mobile].selected_digits.push(
        Number(ticket_number)
      );

      Card_data[this.state.selected_digits_mobile].selected_digits = Card_data[
        this.state.selected_digits_mobile
      ].selected_digits.sort((a, b) => {
        if (Array.isArray(b)) return -1;
        if (Array.isArray(a)) return 1;
        return 0;
      });
      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == this.state.selected_digits_mobile) {
            return Object.assign({}, elements, {
              card_count: elements.card_count + 1,
              selected_digits:
                Card_data[this.state.selected_digits_mobile].selected_digits,
            });
          } else return elements;
        }),
      }));

      selectedCard.classList.add("card__onClick");
    }
    if (
      this.state.card_data[this.state.selected_digits_mobile].card_count ==
      this.state.current_lottery.maximum_digits +
        this.state.current_lottery.max_mega_digits
    ) {
      this.setState({ activateSubmitButton: true });
    }
    return selectedCard;
  }

  // update selected numbers
  updateTicketDigitSelcted(UID, card_arg, ticket_number) {
    let selectedCard = document.querySelector(
      `#ny-lotto #card-${card_arg} #cardText-${UID}`
    );
    if (
      selectedCard.classList.contains("card__onClick") &&
      this.state.card_data[card_arg].card_count >= 0
    ) {
      Card_data[card_arg].selected_digits = Card_data[
        card_arg
      ].selected_digits.filter((item) =>
        item !== Number(ticket_number) ? item : null
      );

      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == card_arg) {
            return Object.assign({}, elements, {
              selected_digits: Card_data[card_arg].selected_digits,
              card_count: elements.card_count - 1,
            });
          } else return elements;
        }),
      }));
      selectedCard.classList.remove("card__onClick");
    } else if (
      !selectedCard.classList.contains("card__onClick") &&
      this.state.card_data[card_arg].card_count <
        this.state.current_lottery.maximum_digits
    ) {
      Card_data[card_arg].selected_digits.push(Number(ticket_number));

      Card_data[card_arg].selected_digits = Card_data[
        card_arg
      ].selected_digits.sort((a, b) => {
        if (Array.isArray(b)) return -1;
        if (Array.isArray(a)) return 1;
        return 0;
      });
      this.setState((prevState) => ({
        card_data: prevState.card_data.map((elements) => {
          if (elements.card_id == card_arg) {
            return Object.assign({}, elements, {
              card_count: elements.card_count + 1,
              selected_digits: Card_data[card_arg].selected_digits,
            });
          } else return elements;
        }),
      }));

      selectedCard.classList.add("card__onClick");
    }
    return selectedCard;
  }

  // add cards/tickets fn
  addTicketCards(event) {
    let UID;
    event.target
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));
    this.state.cardCount + UID <= this.state.maximum_tickets
      ? this.setState({
          cardCount: this.state.cardCount + UID,
          prevClick: UID,
          inputCount: this.state.cardCount + UID,
        })
      : null;
  }

  // card/tickets button undo
  undo() {
    this.state.prevClick > 0
      ? this.setState({
          cardCount: this.state.cardCount - this.state.prevClick,
          inputCount: this.state.cardCount - this.state.prevClick,
          prevClick: 0,
          xCount: this.state.xCount - this.state.prevClick,
        })
      : null;
  }

  // sets state on card results : if less than 10 - popup, more than 10 - no popup
  popup() {
    let count = 0;
    remaining_data.length = 0;

    for (let index = 0; index < this.state.card_data.length; index++) {
      if (
        this.state.card_data[index].selected_digits.length ==
        this.state.current_lottery.maximum_digits +
          this.state.current_lottery.max_mega_digits
      )
        count++;
      else if (
        this.state.card_data[index].selected_digits.length > 0 &&
        this.state.card_data[index].selected_digits.length <
          this.state.current_lottery.maximum_digits +
            this.state.current_lottery.max_mega_digits
      ) {
        remaining_data.push(index);
        remaining_data.length = 1;
      } else remaining_data.length = 0;
    }

    this.setState({ remaining_data: remaining_data, count_popup: count });

    if (count % 10 !== 0) {
      this.setState({
        popup_show: 1,
        popup_heading: DOMPurify.sanitize(t("fewLinesHdr")),
        popup_message:
          DOMPurify.sanitize(t("fewLinesMsg1")) +
          this.state.current_lottery.minimum_lines +
          DOMPurify.sanitize(t("fewLinesMsg2")),
        popup_call_to_action_button: DOMPurify.sanitize(t("fewLinesCTA")),
      });
      return true;
    } else {
      this.setState({ popup_show: false });
      return false;
    }
  }

  // handles the back and close clicks on popup
  PopUpOnClick() {
    this.setState(
      () => ({ popup_show: false }),
      () => {
        if (this.state.total_cost_of_tickets.price != 0) {
          document.getElementsByClassName("loader")[0].style = "display: none";
          document.getElementsByClassName(
            "widget-ticket-summary-button"
          )[0].disabled = "";
        }
      }
    );
  }

  popup_continue() {
    document.getElementsByClassName("loader")[0].style = "display: block";
    if (
      document.getElementsByClassName("popup-card__button-quick-pick")[0] &&
      document.getElementsByClassName("popup-card__button-back")[0]
    ) {
      document.getElementsByClassName("popup-card__button-back")[0].disabled =
        "disabled";
      document.getElementsByClassName(
        "popup-card__button-quick-pick"
      )[0].disabled = "disabled";
    }
    this.setState(
      () => ({ ignorePopUp: true }),
      () => {
        this.contPlay();
      }
    );
  }

  // price calculator for both single-ticket and multi-draw ticket
  async calculatePrice() {
    let count = 0;
    for (let index = 0; index < this.state.card_data.length; index++)
      this.state.card_data[index].selected_digits.length >=
      this.state.current_lottery.maximum_digits +
        this.state.current_lottery.max_mega_digits
        ? count++
        : null;
    total_cost_of_tickets = (
      Number(this.state.current_lottery.price_per_ticket) *
      count *
      Number(this.state.selectValue[0].draws)
    ).toFixed(2);

    this.setState(
      () => ({
        total_cost_of_tickets: {
          price: total_cost_of_tickets,
        },
      }),
      () => {
        if (this.state.total_cost_of_tickets.price != 0) {
          this.setState({ b_disabled: "" });
        } else {
          this.setState({ b_disabled: "disabled" });
        }
      }
    );
  }

  // quick picks selected
  quickPickSelected() {
    let arg,
      count =
        this.state.current_lottery.minimum_lines -
        (this.state.count_popup % 10);

    if (this.state.cardCount + count < this.state.maximum_tickets)
      this.setState({ cardCount: this.state.cardCount + count });

    if (remaining_data.length == 0) {
      for (let index = 0; index < this.state.card_data.length; index++) {
        let mega = this.state.card_data[index].selected_digits[
          this.state.card_data[index].selected_digits.length - 1
        ]
          ? this.state.card_data[index].selected_digits[
              this.state.card_data[index].selected_digits.length - 1
            ].length
          : 0;

        if (
          this.state.card_data[index].selected_digits.length + mega <
          this.state.current_lottery.maximum_digits +
            this.state.current_lottery.max_mega_digits
        ) {
          remaining_data.push(index);
          if (remaining_data.length == count) break;
        }
      }
    }

    for (let index = 0; index < remaining_data.length; index++) {
      arg = remaining_data[index];

      let allCardNumbers = document.querySelectorAll(
          `#ny-lotto #card-${arg} .card__text.lottery`
        ),
        allMegaNumbers = document.querySelectorAll(
          `#ny-lotto #card-${arg}  .Mega`
        );

      Card_data[arg].selected_digits = this.randomArrayInRange(
        1,
        this.state.current_lottery.digits,
        this.state.current_lottery.maximum_digits
      );
      Card_data[arg].selected_digits.push(
        this.randomNumberInRange(
          1,
          this.state.current_lottery.luckyDigits,
          this.state.current_lottery.max_mega_digits
        )
      );

      {
        let currentArg = arg;

        this.setState((prevState) => ({
          card_data: prevState.card_data.map((elements) => {
            if (elements.card_id === currentArg) {
              return Object.assign({}, elements, {
                card_count: 10,
                Mega_count: 1,
                selected_digits: Card_data[currentArg].selected_digits,
              });
            } else {
              return elements;
            }
          }),
        }));

        // animation on quickpick
        {
          allCardNumbers.forEach((card) => {
            card.classList.remove("card__onClick");
            for (
              let index = 0;
              index < Card_data[currentArg].selected_digits.length;
              index++
            ) {
              let y = Card_data[currentArg].selected_digits;
              if (y[index] == card.innerText && !Array.isArray(y[index]))
                card.classList.add("card__onClick");
            }
          });

          allMegaNumbers.forEach((Mega) => {
            Mega.classList.remove("card__MegaOnClick");
            for (
              let index = 0;
              index < Card_data[currentArg].selected_digits.length;
              index++
            ) {
              let y = Card_data[currentArg].selected_digits;
              if (y[index] == Mega.innerText && Array.isArray(y[index]))
                Mega.classList.add("card__MegaOnClick");
            }
          });
        }
      }
    }

    this.PopUpOnClick();
  }

  //checks for incomplete cards before initializing a popup or continue event
  checkForIncompleteLines() {
    let x = false;
    for (let index = 0; index < this.state.card_data.length; index++) {
      if (
        this.state.card_data[index].selected_digits.length > 0 &&
        this.state.card_data[index].selected_digits.length < 6
      ) {
        this.setState({
          popup_show: 2,
          popup_heading: DOMPurify.sanitize(t("wrongLineHdr")),
          popup_message: DOMPurify.sanitize(t("wrongLineMsg")),
          popup_call_to_action_button: DOMPurify.sanitize(t("wrongLineCTA")),
        });
        x = true;
      }
    }
    return x;
  }

  // adds more cards on button click - more than the default 5. less than the max digit set.
  addMoreCards() {
    this.state.cardCount < 25
      ? this.setState({ cardCount: this.state.cardCount + 5 })
      : null;
  }

  // removes cards  - minimum card results to default set 5.
  addLessCards() {
    this.state.cardCount > 5
      ? this.setState({ cardCount: this.state.cardCount - 5 })
      : null;
  }

  // fn set for mobile devices
  cardMobile() {
    this.clearMobile();

    this.state.mobile_stats
      ? this.setState({ mobile_stats: false })
      : this.setState({ mobile_stats: true });

    this.state.selected_digits_mobile.length == 0
      ? this.setState({ selected_digits_mobile: 1 })
      : this.setState({
          selected_digits_mobile: this.state.selected_digits_mobile + 1,
        });
  }

  //sets state for mobile card devices
  submitMobile() {
    if (
      this.state.card_data[this.state.selected_digits_mobile].selected_digits
        .length <
      this.state.current_lottery.maximum_digits +
        this.state.current_lottery.max_mega_digits
    ) {
      alert("Please fill up the remaining lottery digits to proceed");
      return;
    }

    this.setState({ mobile_editable: true });

    if (
      this.state.card_data[this.state.selected_digits_mobile].selected_digits
        .length > 0 &&
      this.state.card_data[this.state.selected_digits_mobile].selected_digits
        .length <=
        this.state.current_lottery.maximum_digits +
          this.state.current_lottery.max_mega_digits &&
      this.state.current_clicked_id == null
    ) {
      this.setState({
        selected_digits_mobile_click: this.state.selected_digits_mobile + 1,
        selected_digits_mobile: this.state.selected_digits_mobile + 1,
      });
    } else if (this.state.current_clicked_id !== null) return;
    else
      this.setState({
        selected_digits_mobile: this.state.selected_digits_mobile,
      });

    this.clearMobile("submit");
  }

  // sets the edit btn for mobile devices
  editLineFn(event) {
    this.clearMobile();

    let UID,
      currentEvent = event.target.getAttribute("id");

    if (currentEvent == null) return;

    currentEvent
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));

    let allCardNumbers = document.querySelectorAll(`.card.mobile .card__text`),
      allMegaNumbers = document.querySelectorAll(`.card.mobile .Mega`);

    allCardNumbers.forEach((card) => {
      card.classList.remove("card__onClick");
      for (
        let index = 0;
        index < Card_data[UID].selected_digits.length;
        index++
      ) {
        let y = Card_data[UID].selected_digits;
        if (y[index] == card.innerText && !Array.isArray(y[index]))
          card.classList.add("card__onClick");
      }
    });

    allMegaNumbers.forEach((Mega) => {
      Mega.classList.remove("card__MegaOnClick");
      for (
        let index = 0;
        index < Card_data[UID].selected_digits.length;
        index++
      ) {
        let y = Card_data[UID].selected_digits;
        if (y[index] == Mega.innerText && Array.isArray(y[index]))
          Mega.classList.add("card__MegaOnClick");
      }
    });

    this.setState((prevState) => ({
      card_data: prevState.card_data.map((elements) => {
        if (elements.card_id == UID && elements.selected_digits.length !== 0) {
          return Object.assign({}, elements, {
            selected_digits: [],
            card_count: 0,
            Mega_count: 0,
          });
        } else return elements;
      }),
    }));
    Card_data[UID].selected_digits = [];

    if (this.state.mobile_stats) {
      this.setState({ mobile_stats: false });
      document
        .querySelectorAll(".card__edit-lines")
        .forEach((element, id) =>
          id > UID
            ? (element.classList.remove("none"),
              element.classList.add("display"))
            : null
        );
    } else {
      this.setState({ mobile_stats: true });
      document
        .querySelectorAll(".card__edit-lines")
        .forEach((element, id) =>
          id > UID
            ? (element.classList.remove("display"),
              element.classList.add("none"))
            : null
        );
    }
  }

  handleTabClick = (tabIndex) => {
    sessionStorage.setItem("activeTabIndex", tabIndex);
  };

  render() {
    const isPlayTab = 1;

    const activeTabIndex = sessionStorage.getItem("activeTabIndex") || 1;

    const { t } = this.props;

    return (
      <Router>
        <section className="section">
          <div className="TabBody">
            {isPlayTab == activeTabIndex && (
              <>
                <div className="card-content">
                  {/* popup */}
                  <PopUp
                    CTA_message={this.state.popup_call_to_action_button}
                    dashboard_button_text={this.state.popup_dashboard_text}
                    development_mode={this.state.development_mode}
                    handleChange={this.handleChange}
                    handleContinue={this.popup_continue}
                    popup_button_back={this.state.popup_button_back}
                    popup_errors={this.state.popup_errors}
                    popup_heading={this.state.popup_heading}
                    popup_message={this.state.popup_message}
                    popup_show={this.state.popup_show}
                    PopUpPlayNow={this.contPopUp}
                    PopUpDashRedirect={this.redirectDash}
                    PopUpOnClick={this.PopUpOnClick}
                    PopUpPlayAgain={this.playAgain}
                    quickPickSelected={this.quickPickSelected}
                  />
                  <LottoHeader
                    state={this.state}
                    bootstrap={lotteryTicketNumbers}
                    t={t}
                  />
                  <div className="card-content__control-buttons">
                    <button
                      className="card-content__quick-pick-all"
                      title="select all tickets by Quick-Pick All"
                      onClick={this.allQuickPick}
                    >
                      {DOMPurify.sanitize(t("quickPickAll"))}
                    </button>
                    <button
                      className="card-content__clear-all"
                      title="clear all the selected lottery tickets"
                      onClick={() => {
                        this.setState((prevState) => ({
                          card_data: prevState.card_data.map((elements) => {
                            return Object.assign({}, elements, {
                              selected_digits: [],
                              card_count: 0,
                              Mega_count: 0,
                            });
                          }),
                        }));

                        Card_data.map((item) => (item.selected_digits = []));
                        for (let index = 0; index < Card_data.length; index++) {
                          let cardSelect = document.querySelectorAll(
                              `#card-${index} .card__text`
                            ),
                            MegacardSelect = document.querySelectorAll(
                              `#card-${index} .Mega`
                            );

                          cardSelect.forEach((item) =>
                            item.classList.contains("card__onClick")
                              ? item.classList.remove("card__onClick")
                              : null
                          );

                          MegacardSelect.forEach((item) =>
                            item.classList.contains("card__MegaOnClick")
                              ? item.classList.remove("card__MegaOnClick")
                              : null
                          );
                        }
                      }}
                    >
                      {" "}
                      {DOMPurify.sanitize(t("clearAll"))}{" "}
                    </button>
                  </div>
                  <div className="card-content__minimum">
                    <span>{DOMPurify.sanitize(t("10linesMsg"))}</span>
                  </div>

                  {/* load cards component */}
                  <div className="cards">
                    <Card
                      CardCount={this.state.cardCount}
                      cardData={this.state.card_data}
                      clear={this.clear}
                      current_lottery={this.state.current_lottery}
                      isPresentable={this.state.isPresentable}
                      quickPick={this.quickPick}
                      updateMegaSelected={this.updateMegaSelected}
                      updateTicketDigitSelcted={this.updateTicketDigitSelcted}
                      t={t}
                    />

                    <CardMobile
                      CardCount={this.state.cardCount}
                      cardData={this.state.card_data}
                      cardMobile={this.cardMobile}
                      clear={this.clearMobile}
                      current_lottery={this.state.current_lottery}
                      deleteMobile={this.deleteMobile}
                      editLineFn={this.editLineFn}
                      isPresentable={this.state.isPresentable}
                      mobile_editable={this.state.mobile_editable}
                      mobile_stats={this.state.mobile_stats}
                      quickPick={this.quickPickMobile}
                      quickPickEdit={this.quickPickEdit}
                      quickPickSingle={this.quickPickSingle}
                      selected_digits_mobile_click={
                        this.state.selected_digits_mobile_click
                      }
                      selected_digits_mobile={this.state.selected_digits_mobile}
                      setCardState={this.setCardState}
                      total_cost_of_tickets={this.state.total_cost_of_tickets}
                      updateMegaSelectedMobile={this.updateMegaSelectedMobile}
                      updateTicketDigitSelcted={
                        this.updateTicketDigitSelctedMobile
                      }
                      submitMobile={this.submitMobile}
                      t={t}
                    />
                  </div>
                  <div className="card__control-buttons">
                    <button
                      onClick={this.addLessCards}
                      className="card__btn-less"
                    >
                      {" "}
                      {DOMPurify.sanitize(t("buttonLess"))}{" "}
                    </button>
                    <button
                      onClick={this.addMoreCards}
                      className="card__btn-more"
                    >
                      {DOMPurify.sanitize(t("buttonMore"))}
                    </button>
                  </div>
                </div>

                {/* additional buttons */}
                <div className=" pull-left widget-ticket-additional-form-box">
                  <div className="platform-form">
                    <span
                      className="widget-ticket-additional-form-header"
                      title="Choose the type of ticket"
                    >
                      {DOMPurify.sanitize(t("drawsHeader"))}
                    </span>
                    <div className="widget-ticket-additional-form">
                      <div className="form-group" title=" 1 draw">
                        <this.Input
                          type="radio"
                          name="powerAustralia"
                          id="ticket_type"
                          value="1"
                          checked={this.state.ticket_options[0].iChecked}
                          handleClick={this.handleCheckbox}
                          text={DOMPurify.sanitize(t("button1Draw"))}
                          data_tickets="1"
                        />
                      </div>
                      <div className="form-group" title=" 2 draws">
                        <this.Input
                          type="radio"
                          name="powerAustralia"
                          id="ticket_type"
                          value="2"
                          checked={this.state.ticket_options[0].iChecked2}
                          handleClick={this.handleCheckbox}
                          text={DOMPurify.sanitize(t("button2Draw"))}
                          data_tickets="2"
                        />
                      </div>
                      <div className="form-group" title=" 4 draws">
                        <this.Input
                          type="radio"
                          name="powerAustralia"
                          id="ticket_type"
                          value="4"
                          checked={this.state.ticket_options[0].iChecked4}
                          handleClick={this.handleCheckbox}
                          text={DOMPurify.sanitize(t("button4Draw"))}
                          data_tickets="4"
                        />
                      </div>
                      <div className="form-group" title=" 8 draws">
                        <this.Input
                          type="radio"
                          name="powerAustralia"
                          id="ticket_type"
                          value="8"
                          checked={this.state.ticket_options[0].iChecked8}
                          handleClick={this.handleCheckbox}
                          text={DOMPurify.sanitize(t("button8Draw"))}
                          data_tickets="8"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="clearfix"></div>
                </div>

                {/* submit button */}
                <div className="widget-ticket-button-wrapper">
                  <div className="pull-right widget-ticket-summary">
                    <div
                      className="widget-ticket-summary-content-total"
                      title="total sum calculated"
                    >
                      {DOMPurify.sanitize(t("sumText"))}&nbsp;&euro;
                      <span>{this.state.total_cost_of_tickets["price"]}</span>
                    </div>
                    <div className="btn__wrap">
                      <this.Button
                        id="subButton"
                        className="btn btn-primary pull-left widget-ticket-summary-button btn-mobile-large"
                        type="submit"
                        handleClick={this.contPlay}
                        disabled={this.state.b_disabled}
                        text={DOMPurify.sanitize(t("buttonContinue"))}
                        title={DOMPurify.sanitize(t("buttonContinueTitle"))}
                      />
                      <div className="loader">
                        <div className="loading"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
      </Router>
    );
  }
}
const mapStateToProps = (state) => ({
  lotto_aff: state.state.lotto_aff,
  lotto_miniState: state.state.lotto_miniState,
});

export default connect(mapStateToProps)(withTranslation()(WidgetFrontend));
